import posthog from 'posthog-js'

export default {
  install(Vue) {
    posthog.init(process.env.VUE_APP_POSTHOG_API_KEY, {
      api_host: process.env.VUE_APP_POSTHOG_API_HOST,
      defaults: process.env.VUE_APP_POSTHOG_DEFAULTS,
      autocapture: false
    })

    Vue.prototype.$posthog = posthog
  }
}
